import styles from '@features/showrooms/sections/ShowroomsSection/Components/LogoBar/LogoBar.styles';
import { BASE_PATH } from '@config/index';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
const logoScrollSpace = 1079; // sum of image widths and image margin right

const LogoBar = () => <div sx={styles.container(logoScrollSpace)}>
    <div>
      <div>
        <ResponsiveImage width={44} height={32} image={`${BASE_PATH}/img/logo/vox.png`} alt="vox" />
        <ResponsiveImage width={80} height={32} image={`${BASE_PATH}/img/logo/pol-skone.png`} alt="pol-skone" />
        <ResponsiveImage width={97} height={32} image={`${BASE_PATH}/img/logo/class-en.png`} alt="class-en" />
        <ResponsiveImage width={73} height={32} image={`${BASE_PATH}/img/logo/vilo.png`} alt="vilo" />
        <ResponsiveImage width={114} height={32} image={`${BASE_PATH}/img/logo/erkado.png`} alt="erkado" />
        <ResponsiveImage width={68} height={32} image={`${BASE_PATH}/img/logo/porta.png`} alt="porta" />
        <ResponsiveImage width={100} height={32} image={`${BASE_PATH}/img/logo/egger.png`} alt="egger" />
        <ResponsiveImage width={76} height={32} image={`${BASE_PATH}/img/logo/dre.png`} alt="dre" />
        <ResponsiveImage width={67} height={32} image={`${BASE_PATH}/img/logo/quick-step.png`} alt="quick-step" />
      </div>
      <div>
        <ResponsiveImage width={44} height={32} image={`${BASE_PATH}/img/logo/vox.png`} alt="vox" />
        <ResponsiveImage width={80} height={32} image={`${BASE_PATH}/img/logo/pol-skone.png`} alt="pol-skone" />
        <ResponsiveImage width={97} height={32} image={`${BASE_PATH}/img/logo/class-en.png`} alt="class-en" />
        <ResponsiveImage width={73} height={32} image={`${BASE_PATH}/img/logo/vilo.png`} alt="vilo" />
        <ResponsiveImage width={114} height={32} image={`${BASE_PATH}/img/logo/erkado.png`} alt="erkado" />
        <ResponsiveImage width={68} height={32} image={`${BASE_PATH}/img/logo/porta.png`} alt="porta" />
        <ResponsiveImage width={100} height={32} image={`${BASE_PATH}/img/logo/egger.png`} alt="egger" />
        <ResponsiveImage width={76} height={32} image={`${BASE_PATH}/img/logo/dre.png`} alt="dre" />
        <ResponsiveImage width={67} height={32} image={`${BASE_PATH}/img/logo/quick-step.png`} alt="quick-step" />
      </div>
    </div>
  </div>;
export default LogoBar;